import { createApi } from '@reduxjs/toolkit/query/react';

import fetchBaseQuery from '../fetchBaseQuery';

const environmentApi = createApi({
    reducerPath: 'environmentApi',
    baseQuery: fetchBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        getEnvironment: builder.query<{ version: string }, void>({
            query: () => ({
                method: 'GET',
                url: '/env',
            }),
        }),
    }),
});

export const { useGetEnvironmentQuery, useLazyGetEnvironmentQuery } = environmentApi;

export default environmentApi;
